/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withUnauthSeoExperiments from 'app/common/lib/react/withUnauthSeoExperiments';
import { calculatePinAttributionTitleNumLines } from 'app/common/react/components/growth/unauth/pin/pinUtils';
import { getAttributionTitleText } from 'app/packages/pin-utils/unauthPinUtils';

const styles = {
  richPinInfoWrapper: {
    overflow: 'hidden',
  },
  title: {
    clear: 'both',
    color: '#444',
    fontSize: 16,
    fontWeight: 'bold',
    padding: '4px 0 2px',
    WebkitFontSmoothing: 'antialiased',
  },
};

class PinAttributionTitle extends Component {
  renderRichPinInfo = (text, locale, inSemanticGroup) => {
    const numLinesForTitle = calculatePinAttributionTitleNumLines(text, locale);
    const innerHtml = (
      <h3
        className={
          'PinAttributionTitle__title PinAttributionTitle__' + numLinesForTitle + 'LineTitle'
        }
        key="pin-attribution-title"
        style={inSemanticGroup ? null : styles.title}
      >
        {text}
      </h3>
    );
    return inSemanticGroup ? (
      <figcaption style={styles.richPinInfoWrapper}>{innerHtml}</figcaption>
    ) : (
      <div style={styles.richPinInfoWrapper}>{innerHtml}</div>
    );
  };

  render() {
    // Note: any logic that would changes the height of any part of the pin that is visible on pageload
    // should be added to methods in pinUtils.js so that it can be used to measure height of pin on server
    const { pin, inPinGridOptGroup } = this.props;

    const text = getAttributionTitleText(pin);
    return inPinGridOptGroup ? (
      this.renderRichPinInfo(text, this.context.locale, true)
    ) : (
      <div>{this.renderRichPinInfo(text, this.context.locale, false)}</div>
    );
  }
}

PinAttributionTitle.propTypes = {
  pin: PropTypes.shape({
    id: PropTypes.string,
    domain: PropTypes.string.isRequired,
    place_summary: PropTypes.object,
    rich_summary: PropTypes.object,
  }).isRequired,
  inPinGridOptGroup: PropTypes.bool,
};

PinAttributionTitle.contextTypes = {
  pageType: PropTypes.string,
  locale: PropTypes.string.isRequired,
};

export default connect()(withUnauthSeoExperiments(PinAttributionTitle));
